var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "archive" }, [
    _c("h2", [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _vm.text
      ? _c("p", { staticClass: "archive__text" }, [_vm._v(_vm._s(_vm.text))])
      : _vm._e(),
    _vm._v(" "),
    _vm.hero
      ? _c("div", {
          staticClass: "archive__featured",
          domProps: { innerHTML: _vm._s(_vm.hero) },
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "archive__container" },
      [
        _c("mobile-filter", {
          attrs: {
            categories: _vm.data.categories,
            isShopPage: _vm.data.isShopPage,
            selectedCategories: _vm.selectedCategories,
            hasSubCategories: _vm.data.hasSubCategories,
            category: _vm.category,
            taxonomies: _vm.taxonomies,
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "archive__top" },
          [
            !_vm.data.isShopPage && _vm.data.hasSubCategories
              ? _c("categories", {
                  attrs: {
                    categories: _vm.data.categories,
                    isShopPage: _vm.data.isShopPage,
                    selectedCategories: _vm.selectedCategories,
                    hasSubCategories: _vm.data.hasSubCategories,
                    category: _vm.category,
                    mobile: false,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.taxonomies, function (taxonomy) {
              return _c("taxonomy", {
                key: taxonomy.name,
                attrs: { taxonomy: taxonomy, mobile: false },
              })
            }),
            _vm._v(" "),
            _vm.data.hasSubCategories || _vm.taxonomies.length
              ? _c(
                  "button",
                  {
                    staticClass: "archive__clear",
                    class: {
                      "archive__clear--disabled":
                        _vm.selectedCategories.length === 0 &&
                        _vm.selectedTaxonomyIds.length === 0,
                    },
                    on: { click: _vm.clearAll },
                  },
                  [_vm._v("\n        Rensa alla val\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("sort", { attrs: { mobile: false } }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "archive__products archive__products-no-subs" },
          _vm._l(_vm.products, function (product) {
            return _c(
              "li",
              { key: product.id, staticClass: "product-card" },
              [
                _c("product", {
                  attrs: { showSupplier: true, product: product },
                }),
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.showLoadMore
          ? _c(
              "p",
              {
                staticClass: "archive__more",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.more.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Ladda fler")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/ArchiveProduct.vue